

export default function AboutHighlight() {
  return (
    <>
      

      <section className="relative z-[5] mt-[0px] px-[80px] pb-[60px] max-lg:px-6 max-lg:mt-[-50px]">
  <div className="max-w-[1200px] mx-auto grid grid-cols-3 gap-[28px] max-lg:grid-cols-1">

    {/* CARD 1 */}
    <div className="bg-white rounded-[16px] px-[28px] pt-[32px] pb-[34px] text-left shadow-[0_10px_30px_rgba(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(0,0,0,0.18)] max-lg:text-center">
      <div className="w-[42px] h-[42px] rounded-full bg-[#e8f5e9] text-[#1b5e20] flex items-center justify-center text-[18px] font-bold mb-[18px] max-lg:mx-auto">
        ✓
      </div>
      <h4 className="text-[15px] tracking-[0.6px] font-semibold mb-[8px] text-[#1b1b1b]">
        ASSURED LEGAL TITLE
      </h4>
      <p className="text-[14.5px] leading-[1.6] text-[#555]">
        We provide legal, government-approved and RERA approved plots in Nagpur with bank loan support.
      </p>
    </div>

    {/* CARD 2 */}
    <div className="bg-white rounded-[16px] px-[28px] pt-[32px] pb-[34px] text-left shadow-[0_10px_30px_rgba(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(0,0,0,0.18)] max-lg:text-center">
      <div className="w-[42px] h-[42px] rounded-full bg-[#e8f5e9] text-[#1b5e20] flex items-center justify-center text-[18px] font-bold mb-[18px] max-lg:mx-auto">
        ✓
      </div>
      <h4 className="text-[15px] tracking-[0.6px] font-semibold mb-[8px] text-[#1b1b1b]">
        FLEXIBLE PAYMENT TERMS
      </h4>
      <p className="text-[14.5px] leading-[1.6] text-[#555]">
        Payment terms suitable to your real estate budget and plot investment plan.
      </p>
    </div>

    {/* CARD 3 */}
    <div className="bg-white rounded-[16px] px-[28px] pt-[32px] pb-[34px] text-left shadow-[0_10px_30px_rgba(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(0,0,0,0.18)] max-lg:text-center">
      <div className="w-[42px] h-[42px] rounded-full bg-[#e8f5e9] text-[#1b5e20] flex items-center justify-center text-[18px] font-bold mb-[18px] max-lg:mx-auto">
        ✓
      </div>
      <h4 className="text-[15px] tracking-[0.6px] font-semibold mb-[8px] text-[#1b1b1b]">
        TIMELY DELIVERY
      </h4>
      <p className="text-[14.5px] leading-[1.6] text-[#555]">
        You get timely delivery of your residential plots with clear project communication.
      </p>
    </div>

  </div>
</section>
    </>
  );
}
